import { ValidatorFn, Validators } from '@angular/forms';
import { ExtensionConfig } from '../vip-process/model';
import { DatePickerExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { getExtensionRules } from '../../../shared/all-extension-rules';
import { GeoRules } from './components/date-picker-geo-rules/configs';
import { BlackoutDatesRules } from './components/date-picker-blackout-dates/configs';

function GeoFenceMethodValidator(): ValidatorFn {
  return (control: any): { [key: string]: any } | null => {
    if (control.value === 'geoRules' && control?._parent?.controls['geoRules']?.value?.length == 0) {
      return { missingGeoRules: '*Required at least one geo rule' };
    } else {
      return null;
    }
  };
}

export const DatePickerConfig: ExtensionConfig[] = [
  {
    fieldName: 'internalName',
    defaultValue: '',
    validators: [Validators.required],
  },
  {
    fieldName: 'type',
    defaultValue: DatePickerExtension.DeliveryDatePickerType.DATE_FIELD,
    validators: [Validators.required],
  },
  {
    fieldName: 'title',
    defaultValue: 'Schedule delivery in Toronto',
    validators: [Validators.required],
  },
  {
    fieldName: 'description',
    defaultValue: "You'll choose a date and time at checkout",
  },
  {
    fieldName: 'label',
    defaultValue: 'Label',
  },
  {
    fieldName: 'deliveryServiceInventoryLocationId',
    validators: [Validators.required],
    defaultValue: null,
  },
  {
    fieldName: 'geoFenceMethod',
    defaultValue: DatePickerExtension.GeoFenceType.DOMESTIC,
    validators: [GeoFenceMethodValidator()],
  },
  {
    fieldName: 'firstAvailableDate',
    defaultValue: 0,
  },
  {
    fieldName: 'lastAvailableDate',
    defaultValue: 30,
  },
  {
    fieldName: 'firstAvailableDateType',
    defaultValue: 'businessDays',
  },
  {
    fieldName: 'skipFirstAvailableDateSelection',
    defaultValue: false,
  },
  {
    fieldName: 'lastAvailableDateType',
    defaultValue: 'businessDays',
  },
  {
    fieldName: 'placementMode',
    defaultValue: 'standalone',
  },
  {
    fieldName: 'activeShippingDays',
    defaultValue: [],
    type: 'formArray',
  },
  {
    fieldName: 'restrictionsRules',
    defaultValue: [],
    type: 'formArray',
    rulesConfig: getExtensionRules(),
  },
  {
    fieldName: 'geoRules',
    defaultValue: [],
    type: 'formArray',
    rulesConfig: GeoRules,
  },
  {
    fieldName: 'blackoutDatesRules',
    defaultValue: [],
    type: 'formArray',
    rulesConfig: BlackoutDatesRules,
  },
  {
    fieldName: 'externalVendors',
    defaultValue: [],
  },
];
export const DefaultVendorConfigs: {
  [K in DatePickerExtension.ExternalVendorType]: DatePickerExtension.Integrations[K];
} = {
  [DatePickerExtension.ExternalVendorType.URBAN_STEMS]: {
    appSyncUrl: '',
    retailerKey: '',
    skuPrefix: [],
  },
};
export const AvailabilityDatesTypeDisplayNameMap: Record<string, string> = {
  [DatePickerExtension.AvailableDateType.BUSINESS_DAYS]: 'Business days',
  [DatePickerExtension.AvailableDateType.CALENDAR_DAYS]: 'Calendar days',
};
export interface ExternalVendor<
  T extends DatePickerExtension.ExternalVendorType = DatePickerExtension.ExternalVendorType,
> {
  type: T;
  label: string;
  checked: boolean;
  config: DatePickerExtension.Integrations[T];
}
